import { render, staticRenderFns } from "./configure-ui.vue?vue&type=template&id=659424a4&scoped=true&"
import script from "./configure-ui.vue?vue&type=script&lang=ts&"
export * from "./configure-ui.vue?vue&type=script&lang=ts&"
import style0 from "./configure-ui.vue?vue&type=style&index=0&id=659424a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "659424a4",
  null
  
)

export default component.exports